// extracted by mini-css-extract-plugin
module.exports = {"card":"common-card_card__eXSKV","card-name":"common-card_card-name__QDVaH","card-content":"common-card_card-content__MiMjH"};